import React from 'react';
import './StudentLMSMain.css';

const StudentLMSMain = () => (
  <div className="academy-page-shell student-lms-main">
    <div className="lms-main-welcome">
      <h1>Welcome, Student!</h1>
      <p className="lms-main-desc">Access your courses, assignments, and grades. Use the sidebar to explore your learning tools.</p>
      <div className="lms-main-graphic student"></div>
    </div>
  </div>
);

export default StudentLMSMain;
